module.exports = __webpack_public_path__ + "img/album18_34.35289e7c.jpg";